import { createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
	data: null,
	isFetching: false,
	isSuccess: false,
	isError: false,
	error: null,
});

const actionButtonApiCall = createSlice({
	name: "actionButtonApiCall",
	initialState: INITIAL_STATE,
	reducers: {
		actionButtonAPICallRequest: (state) => {
			state.isFetching = true;
		},
		actionButtonAPICallSuccess: (state, action) => {
			state.isFetching = false;
			state.isSuccess = true;
			state.data = action.payload;
		},
		actionButtonAPICallFailuer: (state, action) => {
			state.isFetching = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.payload;
		},
		resetActionButtonAPICall: (state) => {
			state.data = null;
			state.error = null;
			state.isError = false;
			state.isFetching = false;
			state.isSuccess = false;
		},
	},
});

// Exporting actions for saga and views
export const {
	actionButtonAPICallRequest,
	actionButtonAPICallSuccess,
	actionButtonAPICallFailuer,
	resetActionButtonAPICall,
} = actionButtonApiCall.actions;

// const selectLogin = (state: any) => state.actionButtonApiCall;

// export const selectLoginData = createSelector(selectLogin, (login) => {
//     return login.data;
// });

// Exporting actionButtonApiCall reducer for combine reducer
export default actionButtonApiCall.reducer;
